// eslint-disable-next-line max-len
// TODO: TODO: Need to refactor: this code the same as wgnp/static_source/components/sms_resend_code/index.js
import withRender from './sms_resend_cellphone_recovery.vue.html';

import promisifiedAjaxRequest from '../../helpers/ajaxrequest/promisifiedAjaxRequest';
import promisifiedPrepareErrors from '../../helpers/promisifiedPrepareErrors';

import BMessageError from '../b_message_error/b_message_error';
import Spinner from '../spinner/spinner';

import getErrorTypeMixin from '../../mixins/getErrorType';

import {
    CELLPHONE_RECOVERY_OPERATIONS,
    CELLPHONE_RECOVERY_OPERATIONS_MUTATION_UPDATE_STATE,
} from '../../constants/cellphone_recovery_operations';

export const RESEND_CELLPHONE_RECOVERY_EVENT = 'resend-cellphone-recovery';

export default withRender({
    name: 'sms-verification-resend-cellphone-recovery',
    mixins: [getErrorTypeMixin],
    components: {
        BMessageError,
        Spinner,
    },

    props: {
        operation: {
            type: String,
            required: true,
            validator(value) {
                return Object.values(CELLPHONE_RECOVERY_OPERATIONS).includes(value);
            },
        },
        sentCodesPropName: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            templatePrefix: 'js-tmpl-sms-verification-resend-cellphone-recovery-error',

            ERRORS_TYPES: {
                requestCode: ['__all__:can_not_request', '__all__:sms_error'],
            },

            error: false,
            errors: [],
            processing: false,

            showTip: false,
            firstRequestSent: false,
            now: Math.floor(Date.now() / 1000),
            updateNowInterval: null,
        };
    },

    computed: {
        operationStore() {
            return this.$store.state[this.operation];
        },
        codeExpiresAt() {
            return this.operationStore.codeExpiresAt;
        },
        codeLimit() {
            return this.operationStore.codeLimit;
        },
        codeLimitTimeout() {
            return this.operationStore.codeLimitTimeout;
        },
        codeRequestTimeout() {
            return this.operationStore.codeRequestTimeout;
        },
        requestNewCodeUrl() {
            return this.operationStore.urls.cellphoneRecoveryResendSmsUrl;
        },
        countrySelectOptions() {
            return this.operationStore.CountrySelectOptions;
        },
        sentCodes() {
            return this.operationStore[this.sentCodesPropName];
        },
        requestButtonDisabled() {
            if (this.firstRequestSent && this.codeExpiresAt) {
                const isCodeAlive = this.now <= this.codeExpiresAt;

                return isCodeAlive;
            }

            return false;
        },
        countryCodeLetters() {
            return this.getCountryCodeLetters();
        },
        shortCellphone() {
            return this.getShortCellphone();
        },
    },

    methods: {
        // Общий метод для поиска страны по номеру
        findCountryOptionByNumber(fullNumber) {
            if (!fullNumber) return null;
            return this.countrySelectOptions.find(option => {
                const codeStr = String(option.cellphone_code);
                return fullNumber.startsWith(codeStr);
            });
        },
        // Получение кода страны
        getCountryCodeLetters() {
            const fullNumber = this.operationStore.cellphone;
            const countryOption = this.findCountryOptionByNumber(fullNumber);
            return countryOption ? countryOption.value : '';
        },
        // Получение короткого номера
        getShortCellphone() {
            const fullNumber = this.operationStore.cellphone;
            const countryOption = this.findCountryOptionByNumber(fullNumber);
            if (countryOption) {
                const codeLength = String(countryOption.cellphone_code).length;
                return fullNumber.slice(codeLength);
            }
            return fullNumber;
        },
        toggleTip() {
            this.showTip = !this.showTip;
        },
        updateNow() {
            this.now = Math.floor(Date.now() / 1000);
        },
        async requestNewCode() {
            if (this.requestButtonDisabled || this.processing) {
                return;
            }

            this.processing = true;
            this.error = false;
            const data = new FormData();
            data.append('country_code', this.countryCodeLetters);
            data.append('cellphone', this.shortCellphone);

            try {
                await promisifiedAjaxRequest({
                    url: this.requestNewCodeUrl,
                    method: 'POST',
                    data
                });

                let sentCodes = this.sentCodes + 1;

                let codeExpiresAt;

                if (sentCodes < this.codeLimit) {
                    codeExpiresAt = this.now + this.codeRequestTimeout;
                } else {
                    codeExpiresAt = this.now + this.codeLimitTimeout;
                    sentCodes = 0;
                }

                // eslint-disable-next-line max-len
                const updateStateMutation = CELLPHONE_RECOVERY_OPERATIONS_MUTATION_UPDATE_STATE[this.operation];

                this.$store.commit(updateStateMutation, {
                    codeExpiresAt,
                    [this.sentCodesPropName]: sentCodes,
                });
            } catch (xhrError) {
                const { errors } = await promisifiedPrepareErrors(xhrError);

                this.error = true;
                this.errors = errors;

                if (!this.errorType.requestCode) {
                    this.$emit('error', xhrError);
                }
            }

            if (!this.error || this.errorType.requestCode) {
                this.firstRequestSent = true;
            }

            this.processing = false;
        },
    },

    mounted() {
        this.updateNowInterval = setInterval(this.updateNow, 1000);

        this.$on(RESEND_CELLPHONE_RECOVERY_EVENT, () => {
            this.showTip = true;
            this.requestNewCode();
        });
    },

    beforeDestroy() {
        clearInterval(this.updateNowInterval);
        this.updateNowInterval = null;
        this.$off(RESEND_CELLPHONE_RECOVERY_EVENT);
    },
});
